import { RiDeleteBin5Fill } from "react-icons/ri";
import { BiEditAlt } from "react-icons/bi";
import {
  CanAccess,
  AuthorizationList,
} from "../../../components/template/authorization/Authorization";

export const initFilterInput = {
  searchName: "",
  outlet: [],
  role: "",
  page: 1,
  pageSize: 10,
};

export const renderColumns = (
  handleEdit,
  handleDelete,
  handleDetail,
  handleSendEmail
) => {
  return [
    {
      dataIndex: "employeeId",
      key: "employeeId",
      title: "ID Pegawai",
    },
    {
      dataIndex: "name",
      key: "name",
      title: "Nama Pegawai",
      render: (text, record) => (
        <div
          onClick={() => handleDetail(record)}
          style={{
            textTransform: "capitalize",
            cursor: "pointer",
          }}
        >
          {text}
        </div>
      ),
    },
    {
      dataIndex: "email",
      key: "email",
      title: "Email",
    },
    {
      dataIndex: "outlet",
      key: "outlet",
      title: "Cabang",
    },
    {
      dataIndex: "role",
      key: "role",
      title: "Role",
    },
    {
      dataIndex: "verify",
      key: "verify",
      title: "Verifikasi",
      render: (text, record) => (
        <div
          onClick={() => handleSendEmail(record)}
          style={{
            color: !text ? "#2C465C" : "#A6A6A6",
            fontWeight: !text ? "600" : "500",
            pointerEvents: text && "none",
            cursor: "pointer",
          }}
        >
          Kirim Email
        </div>
      ),
    },
    {
      dataIndex: "lastLogin",
      key: "lastLogin",
      title: "Terakhir Login",
    },
    {
      dataIndex: "status",
      key: "status",
      title: "Status Akun",
      render: (text) => (
        <div
          style={{
            color: text === "Aktif" ? "#56D453" : "#EF5353",
            textTransform: "capitalize",
          }}
        >
          {text}
        </div>
      ),
    },

    {
      dataIndex: "action",
      key: "action",
      title: "Aksi",
      width: "10%",
      render: (_, record) => (
        <div className="col-1 d-flex justify-content-center flex-row">
          <CanAccess
            role={AuthorizationList.update_user}
            yes={
              <div className="mr-2">
                <BiEditAlt
                  onClick={() => handleEdit(record)}
                  style={{
                    fontSize: 24,
                    color: "#F5CB58",
                    cursor: "pointer",
                  }}
                />
              </div>
            }
          />

          <CanAccess
            role={AuthorizationList.delete_user}
            yes={
              <div
                className="mr-2"
                style={{
                  pointerEvents: record.status !== "Non Aktif" && "none",
                }}
                onClick={() => handleDelete(record)}
              >
                <RiDeleteBin5Fill
                  style={{
                    fontSize: 24,
                    color:
                      record.status !== "Non Aktif" ? "#D6D6D6" : "#F23434",
                    cursor: "pointer",
                  }}
                />
              </div>
            }
          />
        </div>
      ),
    },
  ];
};
